// extracted by mini-css-extract-plugin
module.exports = {"frame":"KnowledgeBaseEventManager_frame__j5TGB"};